import { v4 as uuidv4 } from 'uuid';
import { Action, AgentParticipant, EndpointParticipant } from "./conversation.model";
import { EndpointRank } from '../../../sdk/Alg/chat-constants';


export class VoiceConversationModel {
  _id?: any;
  uuid: string;
  revision: string;
  status: string;
  vrsn: string;
  voice_conversation_type: string;
  create_date: Date;
  update_date: Date;
  caller_phone_number: string;
  endpoint_participants: EndpointParticipant[];
  provider?: string;
  voice_chat_id?: string;
  missed_calls?: number;
  preferred_qr_code?: string;
  assign_date?: Date;
  agent_participants?: AgentParticipant[];
  current_task_uuid?: string;
  action?: Action;
  active_session?: boolean;
  agent_participants_outbound?: AgentParticipant[];
  voice_conversation_state?: string;


  constructor(userGuid: string, vcGuid: string, userName: string, vcName: string, chatId: string, channel: string, title: string){
    this.uuid = uuidv4();
    this.revision = uuidv4();
    this.status = "ACTIVE";
    this.voice_conversation_type = "PRIVATE";
    this.voice_chat_id = chatId;
    this.create_date = new Date();
    this.update_date = new Date();
    this.missed_calls = 0;
    const userParticipant: EndpointParticipant = {
      uuid: userGuid,
      rank: EndpointRank.owner,
      name: userName
    }
    const endpointParticipant: EndpointParticipant = {
      uuid: vcGuid,
      rank: EndpointRank.virtual,
      name: vcName
    }
    this.endpoint_participants = [userParticipant, endpointParticipant];
  }

}
